// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"2ec0c26a","613":"ef950fa3","743":"8412ba0f"}[chunkId] + ".chunk.js";
};